import BaseFeature from '../../foundation/base/base';

class Main extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.ticking = false;
		this.main = this.el;
		this.body = window.features.dom.body;
		this.secondaryNavigation = document.querySelector('[data-js="secondaryNavigation"]');
		this.secondaryNavContainer = document.querySelector('.h-section-band-two-column__column-2');
		this.zipcodePrimary = this.el.querySelector('[data-js="zipcodePrimary"]');
		this.footer = document.querySelector('.o-footer');

		this.trackName = document.querySelectorAll('[data-js="trackName"]');
		this.trackCourse = document.querySelectorAll('[data-js="trackCourse"]');
		this.trackAttendee = document.querySelectorAll('[data-js="trackAttendee"]');
		this.trackDigit = document.querySelectorAll('[data-js="trackDigit"]');
		this.trackSummaryDigit = document.querySelector('[data-js="trackSummaryDigit"]');

		this.addClick();
		this.log();
	}


	addClick() {
		// Detect if element is overflow
		function isOverflown(element) {
			return element.scrollWidth > element.clientWidth;
		}
		function reportOverflow() {
			const els = document.getElementsByClassName('o-module-container__content-section');
			for (let i = 0; i < els.length; i++) {
				const el = els[i];
				if (isOverflown(el)) {
					el.classList.add('is-overflow');
				} else {
					el.classList.remove('is-overflow');
				}
			}
		}
		if (document.getElementsByClassName('o-module-container__content-section')) {
			reportOverflow();
			window.onresize = reportOverflow;
		}
		// Appending the Secondary navigation element to the header on breakpoint
		if (this.secondaryNavigation) {
			const mq = window.matchMedia('(min-width: 768px)');
			if (mq.matches) {
				this.secondaryNavContainer.prepend(this.secondaryNavigation);
			} else {
				this.el.prepend(this.secondaryNavigation);
			}

			window.addEventListener('resize', () => {
				if (mq.matches) {
					this.secondaryNavContainer.prepend(this.secondaryNavigation);
				} else {
					this.el.prepend(this.secondaryNavigation);
				}
			});
		}
		if (this.zipcodePrimary) {
			document.querySelector('.o-footer').classList.add('o-footer--frontpage');
		}
	}
}

export default Main;
